export default '/build/49f06b89.svg'